import React from "react";
import Button from "@material-ui/core/Button"; // Material-UI Button component
import Dialog from "@material-ui/core/Dialog"; // Material-UI Dialog component
import DialogActions from "@material-ui/core/DialogActions"; // Material-UI DialogActions component
import DialogContent from "@material-ui/core/DialogContent"; // Material-UI DialogContent component
import DialogContentText from "@material-ui/core/DialogContentText"; // Material-UI DialogContentText component
import DialogTitle from "@material-ui/core/DialogTitle"; // Material-UI DialogTitle component
import styles from "assets/jss/material-dashboard-react/components/businessForm"; // Custom styles for buttons
import { makeStyles } from "@material-ui/core/styles"; // Material-UI makeStyles for custom styling

// Create custom styles using Material-UI's makeStyles
const useBtnStyles = makeStyles(styles);

// ===== OPTION B: SessionOutModal with centralized logout =====
// The logout prop now comes from AdminNavbarLinks which dispatches authLogout Redux action
// No SDK dependencies here
export default function SessionOutModal({
  open, // Boolean to control the visibility of the modal
  close, // Function to handle closing the modal (resume session)
  logout, // Function to handle logout action (now dispatches authLogout Redux action)
  remaining, // Remaining time in seconds before session expires
}) {
  const btnClasses = useBtnStyles();
  const minutes = Math.floor(+remaining / 60);
  const seconds = remaining % 60;
  const formattedMinutes = String(minutes).padStart(2, "0");
  const formattedSeconds = String(seconds).padStart(2, "0");

  const formattedTimeout = `${formattedMinutes}:${formattedSeconds}`;

  return (
    <div>
      {/* Dialog component to display the session timeout modal */}
      <Dialog
        open={open} // Control the visibility of the dialog
        onClose={close} // Handle dialog close action
        aria-labelledby="alert-dialog-title" // Accessibility label for the dialog title
        aria-describedby="alert-dialog-description" // Accessibility description for the dialog content
      >
        {/* Dialog title */}
        <DialogTitle id="alert-dialog-title">
          Your session is about to expire!
        </DialogTitle>
        {/* Dialog content */}
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <p>
              Your session is about to expire. You&apos;ll be automatically signed
              out in
              {" "}
              {formattedTimeout}
              {" "}
              seconds.
            </p>
            <p>Do you want to stay signed in?</p>
          </DialogContentText>
        </DialogContent>
        {/* Dialog actions */}
        <DialogActions>
          {/* Logout button */}
          <Button
            onClick={logout} // Handle logout action
            variant="contained" // Contained button style
            className={btnClasses.clearButton} // Apply custom button styles
          >
            Logout
          </Button>
          {/* Stay signed in button */}
          <Button
            onClick={close} // Handle closing the modal
            variant="contained" // Contained button style
            className={btnClasses.buttonStyle} // Apply custom button styles
          >
            Stay signed in
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
